<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            width="500">
            
            <v-card>
                <v-card-title>{{ $t("PASS_CHNG_TITLE") }}</v-card-title>
                <v-card-subtitle>{{ $t("PASS_CHNG_SUBTITLE") }}</v-card-subtitle>
                <v-card-text>
                    <v-form
                        v-model="valid"
                        ref="form">
                        <v-text-field
                            v-if="!current_password_match"
                            :label="$t('PASS_CHNG_CURRENT_PASS')"
                            v-model="form.current_password"
                            type="password"
                            :loading="loading.form.current_password"
                            :error="error.current_password.error"
                            :error-messages="error.current_password.messages">
                        </v-text-field>
                        <div v-if="current_password_match">
                            <v-text-field
                                :label="$t('PASS_CHNG_PASSWORD')"
                                v-model="form.password"
                                :rules="rules.password"
                                type="password">
                            </v-text-field>
                            <v-text-field
                                :label="$t('PASS_CHNG_PASSWORD_CONF')"
                                v-model="form.password_confirmation"
                                :rules="rules.password_confirmation"
                                type="password">
                            </v-text-field>
                        </div>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        v-if="current_password_match"
                        text
                        :disabled="!valid || loading.form.submit"
                        :loading="loading.form.submit"
                        @click="submit">
                        {{ $t("BTN_SAVE") }}
                    </v-btn>
                    <v-btn
                        v-if="!current_password_match"
                        text
                        @click="submitCheckCurrentPassword"
                        :loading="loading.form.current_password"
                        :disabled="loading.form.current_password">
                        {{ $t("PASS_CHNG_BTN_CHEK") }}
                    </v-btn>
                    <v-btn
                        @click="close"
                        text>
                        {{ $t("BTN_CANCEL") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AlertDialog from './AlertDialog';

export default {
    name: "PasswordChangeDialog",
    components: {
        AlertDialog
    },
    data() {
        return {
            display: false,
            valid: false,
            current_password_match: false,
            form: {
                current_password: null,
                password: null,
                password_confirmation: null
            },
            rules: {
                password: [
                    v => !!v || this.$t("PASS_CHNG_PASSREQUIRED_MSG"),
                    v => v.length >= 8 || this.$t("PASS_MIN8CHAR_MSG")
                ],
                password_confirmation: [
                    v => !!v || this.$t("PASS_CONF_REQ_MSG"),
                    v => v == this.form.password || this.$t("PASS_CONF_MISMAT_MSG")
                ]
            },
            loading: {
                form: {
                    current_password: false,
                    submit: false
                }
            },
            error: {
                current_password: {
                    error: false,
                    messages: null
                }
            }

        }
    },
    computed: {
        ...mapState("authentication", ["loggedInUser"])
    },
    methods: {
        ...mapActions("user", ["checkCurrentPassword", "changeUserPassword"]),
        ...mapActions("authentication", ["logout"]),
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
            this.loading.form.current_password = false;
            this.loading.form.submit = false;
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
            this.setInitialState();
        },
        setMismatchState() {
            this.current_password_match = false;
            this.error.current_password.error = true;
            this.error.current_password.messages = this.$t("PASS_CHNG_MSISMATCH_MSG");
        },
        setMatchState() {
            this.current_password_match = true;
            this.error.current_password.error = false;
            this.error.current_password.messages = null;
        },
        setInitialState() {
            this.clearErrorState();
            this.form.current_password = null;
        },
        clearErrorState() {
            this.current_password_match = false;
            this.error.current_password.error = false;
            this.error.current_password.messages = null;
        },
        submitCheckCurrentPassword() {
            this.loading.form.current_password = true;
            this.clearErrorState();
            this.checkCurrentPassword({
                user_id: this.loggedInUser.id,
                current_password: this.form.current_password
            })
            .then(response => {
                if(response.result === true) this.setMatchState();
                else this.setMismatchState();
                this.loading.form.current_password = false;
            })
            .catch(() => {
                this.current_password_match = false;
                this.loading.form.current_password = false;
            });
        },
        submit() {
            this.loading.form.submit = true;
            this.form.user_id = this.loggedInUser.id;
            this.changeUserPassword(this.form)
                .then(() => {
                    // this.$refs.alertDialog.open("نجاح", response.message);
                    this.logout();
                    this.close();
                })
                .catch(error => {
                    this.$refs.alertDialog.open("فشل", error.message);
                    this.close();
                });
        }
    }
}
</script>